import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styles from './Logo.scss';

import { setScrollTop } from 'actions/objects';
import logo from 'assets/images/logo.svg';
// import logoNg from 'assets/images/logoNg.png';

const Logo = ({ className, nolink, to = '/' }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  // const location = useLocation();

  // const logoSrc = location.pathname.startsWith('/ncollection') ? logo : logoNg;

  const handleClick = (e) => {
    e.preventDefault();
    history.push(sessionStorage.getItem('filtersUrl') || to);
    dispatch(setScrollTop(null));
  };

  return nolink ? (
    <div className={className}>
      <div className={styles.Logo}>
        <img alt="logo" src={logo} />
      </div>
    </div>
  ) : (
    <a href={to} className={className} onClick={handleClick}>
      <div className={styles.Logo}>
        <img alt="logo" src={logo} />
      </div>
    </a>
  );
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Header/Logo/Logo.js